import { css } from "styled-components";
import { mobileOnly } from "./media";

export const pagePadding = css`
  padding: 2.5rem;
  ${mobileOnly`
    padding: 2rem 1rem;
    `}
`;
